<template>
    <button
        @click='emitClick'
        class="button"
        :class="{ 'btn-disabled': disabled }"
    >
        {{ label }}
    </button>
</template>

<script>
export default {
 name: 'vButton',
 props: {
   label: {
     type: String,
     required: true
   },
   disabled: {
     type: Boolean,
     default: false
   },
 },
 methods: {
   emitClick(e) {
     if (!this.disabled) {
       this.$emit('click', e)
     }
   }
 }
}
</script>

<style scoped lang="sass">
    .button
        background: $brand-blue
        color: white
        font-weight: 500
        font-size: $base-font-size
        border: none
        border-radius: 5px
        padding: gridSteps(1) gridSteps(2)
        cursor: pointer
        transition: background 200ms, box-shadow 400ms
        box-shadow: $standard-elevation

        &:hover
            background: $dark-blue
            box-shadow: $elevation-2

        /*&:focus
            outline-color: $dark-blue*/

    .btn-disabled
        background: #999999
        cursor: default
        transition: background 200ms, box-shadow 400ms
        box-shadow: none
        &:hover
            background: #999999
            box-shadow: none
        &:focus
            outline-color: unset

</style>
